module.exports = __webpack_public_path__ + "static/avance_frontal-647963226fa9dbbdcfae05a6c5baf744.jpg";